import { Injectable } from '@angular/core'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { environment } from '../../../environments/environment'

/**
 * Browser telemetry. Every method swallows its own errors: instrumentation must
 * never be able to break a user flow.
 */
@Injectable({
    providedIn: 'root',
})
export class TelemetryService {
    private ai: ApplicationInsights = null

    init(): void {
        try {
            if (this.ai || !environment.appInsightsConnectionString)
                return

            this.ai = new ApplicationInsights({
                config: {
                    connectionString: environment.appInsightsConnectionString,
                    enableAutoRouteTracking: true,
                    disableAjaxTracking: false,
                    disableFetchTracking: false,
                    enableUnhandledPromiseRejectionTracking: true,
                    // Correlation headers are not added to cross-origin calls.
                    // Okta and the API would reject the extra header in preflight.
                    enableCorsCorrelation: false,
                    loggingLevelConsole: 0,
                },
            })

            this.ai.loadAppInsights()

            this.ai.addTelemetryInitializer((item): void => {
                item.data = item.data || {}
                item.data['brand'] = window.location.hostname
                item.data['appVersion'] = environment.appVersion
            })

            this.ai.trackPageView()
        } catch {
            this.ai = null
        }
    }

    event(name: string, properties?: Record<string, string>): void {
        try {
            this.ai?.trackEvent({ name: name }, properties)
        } catch { /* ignored */ }
    }

    setUser(id: string): void {
        try {
            this.ai?.setAuthenticatedUserContext(id, undefined, false)
        } catch { /* ignored */ }
    }
}
